var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "remember-container" }, [
    _c(
      "a",
      {
        staticClass: "forget-container",
        attrs: { href: _setup.rememberUrl, target: "_blank" },
      },
      [_vm._v(_vm._s(_setup.text.forget))]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }